const getters = {
    getterHubInfo: ({ hubInfo }) => hubInfo,
    getterSelectedHubName: ({ hubInfo }) => hubInfo?.validatedHubName,
};
export default getters;
